export default __webpack_public_path__ + "images/YH.27b6cba.png";